//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('componentAlternative', {
//        templateUrl: 'views/components/views/componentAlternative/componentAlternative.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'componentAlternativeService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, componentAlternativeService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
//            let compKeyno = $stateParams.comp_keyno;
//            let componentAlternativeKeyno = $stateParams.componentalternative_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                alternateProdIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.alternate_prod_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await componentAlternativeService.getComponentAlternative({
//                    prod_id: prodId,
//                    comp_keyno: compKeyno,
//                    componentalternative_keyno: componentAlternativeKeyno,
//                }))[0];
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value) {
//                return typeaheadService.searchProduct({ prod_name: value || '' });
//            }

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onSelected = function (item) {
//                if (item) {
//                    vm.model.edit.alternate_prod_id = item?.item_id ?? '';
//                    vm.model.edit.alternate_prod_name = item?.item_name ?? '';
//                } else {
//                    vm.onClear();
//                }
//            }

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onChanged = function (value, item) {
//                vm.model.edit.alternate_prod_name = value;

//                if (value) {
//                    if (item?.item_id) {
//                        vm.model.edit.alternate_prod_id = item.item_id;
//                    }
//                } else {
//                    vm.onClear();
//                }
//            }

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onClear = function () {
//                vm.model.edit.alternate_prod_id = '';
//                vm.model.edit.alternate_prod_name = '';
//            }

//		    // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                componentAlternativeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    componentAlternativeService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: (dialogItself) => {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
